import { apiAuthClient } from 'shared/api/lib';

import type { GetAuthRequestType, GetAuthResponseType } from '../types';

export const getAuthOtp = async ({
  pathParams: { invitationId },
}: GetAuthRequestType) => {
  const url = `/api/v2/invitations/${invitationId}/auth/otp`;

  const { data } = await apiAuthClient.get<GetAuthResponseType>(url);

  return data.data;
};
